module.exports = __webpack_public_path__ + "static/media/logo.ee8bf9f6.svg";